// extracted by mini-css-extract-plugin
export default {"myPageArea":"StoreMyPage_myPageArea__NP5Ng","container":"StoreMyPage_container__6BD9+","content":"StoreMyPage_content__2Zsnz"};